import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

var _templateObject;

var _excluded = ["marketplaceEntity", "href"];
import React from 'react';
import { gql } from '@nerdwallet/apollo';
import BaseReviewLink from './base-review-link';
/**
 * Review link component whose link mapping is derived from the GraphQL provided Marketplace entity.
 */

var GraphQlMarketplaceReviewLink = function GraphQlMarketplaceReviewLink(_ref) {
  var graphQlMarketplaceEntity = _ref.marketplaceEntity,
      hrefOverride = _ref.href,
      props = _objectWithoutProperties(_ref, _excluded);

  var href = hrefOverride || (graphQlMarketplaceEntity === null || graphQlMarketplaceEntity === void 0 ? void 0 : graphQlMarketplaceEntity.reviewLink);
  return /*#__PURE__*/React.createElement(BaseReviewLink, _extends({
    href: href
  }, props));
};

if (process.env.NODE_ENV !== 'production') {
  var PropTypes = require('prop-types'); // eslint-disable-line global-require


  GraphQlMarketplaceReviewLink.propTypes = _objectSpread({
    /** (GraphQL) marketplace entity object */
    marketplaceEntity: PropTypes.shape({
      reviewLink: PropTypes.string
    })
  }, BaseReviewLink.propTypes);
}

GraphQlMarketplaceReviewLink.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment MarketplaceReviewLink on MarketplaceEntityWithReviewInterface {\n    reviewLink\n  }\n"])));
export default GraphQlMarketplaceReviewLink;